export const Actions = Object.freeze({
  //全局通用socket消息事件类型
  SESSION_CONFLICT: 'session.conflict',
  SESSION_CLOSED: 'session.closed',

  TODO_UPDATED: 'event.todo.updated',

  HAZARD_LIVE_MESSAGE: 'event.hazard.liveMessage',

  RISK_UPDATE: 'event.risk.update',

  //培训交互命令（客户端 → 服务端）
  //常规培训和风险评估培训共用一套交互命令
  TRAIN_ENTER: 'command.training.enter',
  TRAIN_LEAVE: 'command.training.leave',
  TRAIN_VERIFY: 'command.training.verify',
  TRAIN_PAUSE: 'command.training.pause',
  TRAIN_PROCEED: 'command.training.proceed',
  TRAIN_SELECT: 'command.training.select',
  TRAIN_NEXT: 'command.training.next',

  APPLY_JOB: 'event.applyJob.default',

  SPECIAL_JOB: 'event.specialJob.default',

  INBOX_MESSAGE_NEW: 'event.inbox.message.new',
  INBOX_MESSAGE_UPDATED: 'event.inbox.message.updated'
})

export default Actions
